import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { fetchPastOrders } from './redux/slices/ordersSlice';
import { fetchAllMenuItems, fetchDBMenuData } from './redux/slices/dbFoodMenuSlice';
import { MenuCategory } from './redux/slices/dbFoodMenuSlice';
import { fetchMe } from './redux/slices/userAuthSlice';
import { fetchBranches } from './redux/slices/branchesSlice';
import { Loading } from './components/Loading';
import { items_icon_paths } from './constants/s3_assets';
import { AppDispatch, useSelector } from './redux/store';
import { preloadImages } from './helpers/preloadImages';
import { preloadImagesOnce } from './helpers/imagePreloaderOnce';

const DataFetcher = ({ children }) => {
    const [dataLoaded, setDataLoaded] = useState(false);
    const [imagesLoaded, setImagesLoaded] = useState(false);
    const userAuth = useSelector((state) => state.userAuth);
    const dispatch = useDispatch<AppDispatch>();

    const s3Url = 'https://pizzahut-assets.s3.amazonaws.com/';
    const itemIconsS3Urls = items_icon_paths.map((path) => s3Url + path);

    const imagesUrls = [
        ...itemIconsS3Urls,
        // require('./assets/images/screen-bg/pizzas/2.jpg'),
        // require('./assets/images/screen-bg/menu/1.jpg'),
        // require('./assets/images/screen-bg/pizzas/faded.png'),
    ];

    const fetchPublicData = async () => {
        // Fetch data that should always be loaded
        const [dbMenuDataResult, menuItemsResult, branchesResult] = await Promise.all([
            dispatch(fetchDBMenuData()),
            dispatch(fetchAllMenuItems()),
            dispatch(fetchBranches()),
        ]);

        const dbMenuData = dbMenuDataResult.payload as MenuCategory[];

        if (!dbMenuData) {
            return;
        }

        // Process background images
        const allBgSrc: string[] = [];
        dbMenuData.forEach((category) => {
            if (category.bg_src) {
                allBgSrc.push(category.bg_src);
            }
            category.sub_categories.forEach((subCategory) => {
                if (subCategory.bg_src) {
                    allBgSrc.push(subCategory.bg_src);
                }
                subCategory.items.forEach((item) => {
                    if (item.bg_src) {
                        allBgSrc.push(item.bg_src);
                    }
                });
            });
            category.items.forEach((item) => {
                if (item.bg_src) {
                    allBgSrc.push(item.bg_src);
                }
            });
        });
        const allImagesUrls = [...imagesUrls, ...allBgSrc];
        preloadImages(allImagesUrls).then(() => {
            setImagesLoaded(true);
            console.log('Images loaded');
        });
        setDataLoaded(true);
    };

    const fetchAuthenticatedData = async () => {
        if (!userAuth.token) {
            return;
        }
        // Fetch data that requires authentication
        // await Promise.all([dispatch(fetchMe()), dispatch(fetchPastOrders())]);
        const [meResponse, ordersResponse] = await Promise.all([
            dispatch(fetchMe()),
            dispatch(fetchPastOrders()),
        ]);
        console.log('fetchMe response:', meResponse);
        const phoneNumber = (meResponse.payload as { phone_number?: string })?.phone_number;
        if (typeof phoneNumber === 'string') {
            console.log('Setting phone number from fetchMe:', phoneNumber);
            localStorage.setItem('phoneNumber', phoneNumber);
        }
    };

    useEffect(() => {
        // Always fetch public data
        fetchPublicData();
    }, []);

    useEffect(() => {
        // Fetch authenticated data when token is available
        if (userAuth.token) {
            fetchAuthenticatedData();
        }
    }, [userAuth.token]);

    return (
        <>
            {dataLoaded ? (
                <div className="w-full h-full p-0 mx-0 my-0">{children}</div>
            ) : (
                <Loading />
            )}
        </>
    );
};

export default DataFetcher;
